export default function Settings() {
    return (
        <div>
            <h1 className="text-3xl font-serif font-bold text-gray-900 mb-8">Paramètres</h1>
            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 text-center text-gray-500">
                Paramètres du site (bientôt disponible)
            </div>
        </div>
    );
}
